import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  header: {
    color: theme.palette.secondary.dark,
  },
  content: {
    fontSize: 14,
    color: '#818080',
    borderBottom: 'none',
  }
}))
